import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCFGASshJTDOl5T3D-MeZi4aPwBTf1Tkcg",
  authDomain: "vantage-trade-assets.firebaseapp.com",
  projectId: "vantage-trade-assets",
  storageBucket: "vantage-trade-assets.appspot.com",
  messagingSenderId: "391200827649",
  appId: "1:391200827649:web:f5d6c56ef314a2ac6d9300",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDtmNsjSnruKS6ZCs3jwqec0QMqGqGKQWk",
//   authDomain: "finance-v2-e1682.firebaseapp.com",
//   projectId: "finance-v2-e1682",
//   storageBucket: "finance-v2-e1682.appspot.com",
//   messagingSenderId: "133386766551",
//   appId: "1:133386766551:web:e0236afa4a4dc881e20892",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
